require('./reference.scss');
const PropTypes = require('prop-types');
const React = require('react');
const ClassNames = require('classnames');
const { OKLink } = require('commonsComponents/OKLink');

const Reference = props => {
    const {
        hasInvestments,
        id,
        link,
        name,
        percentage,
        totalInvestmentAmount,
        modifierClass
    } = props;
    const classGroup = ClassNames('actual-tab-reference',{
        ['actual-tab-reference--' + modifierClass] : modifierClass
    });
    const indicatorCustomClass = `actual-tab-reference__drop--${id}`;
    const referenceLabelClass = ClassNames('actual-tab-reference__label' , {
        [`actual-tab-reference__label--${id}`] : !!id
    });
    const indicatorclass = ClassNames('actual-tab-reference__drop', indicatorCustomClass);
    const percentageClass = ClassNames('actual-tab-reference__percentage', {
        'actual-tab-reference__percentage--empty-state': !hasInvestments || totalInvestmentAmount === 0
    });
    let label;

    if (!!link) {
        label = (
            <OKLink to={link} extraClass="actual-tab-reference__label--link" modifier="inherit-styles">
                {name}
            </OKLink>
        );
    }
    else {
        label = name;
    }

    return (
        <div className={classGroup}>
            <div className="actual-tab-reference__name">
                <div className={indicatorclass} />
                <span className={referenceLabelClass}>
                    {label}
                </span>
            </div>
            <div className={percentageClass}> {percentage}% </div>
        </div>
    );
};
Reference.propTypes = {
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    percentage: PropTypes.string.isRequired,
    hasInvestments: PropTypes.bool,
    totalInvestmentAmount: PropTypes.number,
    link: PropTypes.string,
    modifierClass: PropTypes.string
};

module.exports = Reference;
